import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { homepageWidgetsClient } from '#pplx_generated/typespec/rest/homepage_widgets/client.js';
const TALK_TO_SALES_TARGETING_PATH = '/rest/homepage-widgets/talk-to-sales-targeting';
const TARGETING_REFRESH_INTERVAL_MS = 5 * 60 * 1000;
export function useTalkToSalesTargeting({ enabled, userId, }) {
    const { data, isFetching, isError } = useQuery({
        enabled,
        queryKey: QueryClientHelper.makeQueryKey(TALK_TO_SALES_TARGETING_PATH, { userId }),
        queryFn: async () => {
            const { data, error, response } = await homepageWidgetsClient.GET(TALK_TO_SALES_TARGETING_PATH, 'talk-to-sales-targeting');
            if (error || !data) {
                throw new ApiClientsError('API_CLIENTS_ERROR', {
                    cause: error,
                    status: response.status ?? 0,
                });
            }
            return data.targeted;
        },
        staleTime: TARGETING_REFRESH_INTERVAL_MS,
        gcTime: TARGETING_REFRESH_INTERVAL_MS,
        refetchInterval: TARGETING_REFRESH_INTERVAL_MS,
        refetchIntervalInBackground: false,
        retry: false,
        // Cohort membership must be confirmed by the current request. In addition
        // to IndexedDB hydration, persistence would turn retryable request errors
        // back into cached successes.
        meta: { skipPersistence: true },
    });
    return {
        isLoading: isFetching,
        isError,
        targeted: !isFetching && !isError && (data ?? false),
    };
}
//# sourceMappingURL=useTalkToSalesTargeting.js.map